import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Footer from '../Nav/Footer';

const ContactUS = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [language, setLanguage] = useState('ENG');

  const translations = {
    ENG: {
      contactUs: 'Contact Us',
      messagePrompt: 'Send us a message, and we will get back to you shortly!',
      name: 'Name',
      email: 'Email',
      phone: 'Phone Number',
      message: 'Message',
      send: 'Send Message',
    },
    THAI: {
      contactUs: 'ติดต่อเรา',
      messagePrompt: 'ส่งข้อความถึงเรา แล้วเราจะติดต่อกลับโดยเร็ว!',
      name: 'ชื่อ',
      email: 'อีเมล',
      phone: 'เบอร์โทร',
      message: 'ข้อความ',
      send: 'ส่งข้อความ',
    },
    INDO: {
      contactUs: 'Hubungi Kami',
      messagePrompt: 'Kirim pesan kepada kami, kami akan segera menghubungi Anda!',
      name: 'Nama',
      email: 'Email',
      phone: 'Nomor Telepon',
      message: 'Pesan',
      send: 'Kirim Pesan',
    },
    Malaysia: {
      contactUs: 'Hubungi Kami',
      messagePrompt: 'Hantarkan mesej kepada kami dan kami akan hubungi anda segera!',
      name: 'Nama',
      email: 'Email',
      phone: 'Nombor Telefon',
      message: 'Mesej',
      send: 'Hantar Mesej',
    },
    Phillipines: {
      contactUs: 'Makipag-ugnayan sa Amin',
      messagePrompt: 'Magpadala ng mensahe, at babalikan ka namin agad!',
      name: 'Pangalan',
      email: 'Email',
      phone: 'Numero ng Telepono',
      message: 'Mensahe',
      send: 'Magpadala ng Mensahe',
    },
    LAO: {
      contactUs: 'ຕິດຕໍ່ພວກເຮົາ',
      messagePrompt: 'ຂຽນຂໍ້ຄວາມຫາພວກເຮົາ ແລ້ວພວກເຮົາຈະຕອບກັບທ່ານໃນໄວທີ່ສຸດ!',
      name: 'ຊື່',
      email: 'ອີເມວ',
      phone: 'ເບີໂທ',
      message: 'ຂໍ້ຄວາມ',
      send: 'ສົ່ງຂໍ້ຄວາມ',
    },
    Vietnam: {
      contactUs: 'Liên hệ chúng tôi',
      messagePrompt: 'Gửi tin nhắn và chúng tôi sẽ phản hồi bạn ngay!',
      name: 'Tên',
      email: 'Email',
      phone: 'Số điện thoại',
      message: 'Tin nhắn',
      send: 'Gửi Tin nhắn',
    },
  };

  const t = translations[language];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
  };

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-r from-blue-50 to-blue-100 flex flex-col items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-full max-w-4xl px-6 py-20">
        <h1 className="text-4xl font-bold text-center text-blue-800 mb-6">{t.contactUs}</h1>
        <p className="text-center text-gray-600 mb-12">{t.messagePrompt}</p>

        {/* Contact Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg shadow-lg p-8 space-y-6 border border-gray-200"
        >
          <div>
            <label className="block text-sm text-gray-700 mb-2">{t.name}</label>
            <input
              type="text"
              name="name"
              placeholder={t.name}
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-2">{t.email}</label>
            <input
              type="email"
              name="email"
              placeholder={t.email}
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-2">{t.phone}</label>
            <input
              type="tel"
              name="phone"
              placeholder={t.phone}
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-2">{t.message}</label>
            <textarea
              name="message"
              placeholder={t.message}
              value={formData.message}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              rows="4"
            ></textarea>
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300"
          >
            {t.send}
          </button>
        </form>
      </div>

      {/* Language Selector */}
      <div className="flex justify-content-center mb-6">
        <select
          className="px-4 py-2 border rounded-lg bg-white text-gray-600 focus:outline-none"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="ENG">English</option>
          <option value="THAI">ไทย</option>
          <option value="INDO">Indonesia</option>
          <option value="Malaysia">Malaysia</option>
          <option value="Phillipines">Philippines</option>
          <option value="LAO">ລາວ</option>
          <option value="Vietnam">Vietnam</option>
        </select>
      </div>

      <Footer />
    </motion.div>
  );
};

export default ContactUS;
